import React from 'react';
import { Truck, Upload, RefreshCw, Eye, Trash2 } from 'lucide-react';
import '../../../../styles/components/vehicle-register.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import i18n from '../../../../i18n';
import { getLoggedUser } from '../../../../state/user';
import { toast } from 'react-toastify';
import { getVehicleDetailsById, updateVehicleDetailsRegistration } from './services/VehicleDetailsService';
import { getVehicleType } from '../../../home/pages/VehicleReg/services/sitePassRequest';
import { ConfirmModal } from '../../../common/ConfirmModal';

class VehicleRegistration extends React.Component {
  constructor(props) {
    super(props);
    const isEditMode = !!props.match?.params?.id;

    this.state = {
      isEditMode: isEditMode,
      vehicleId: isEditMode ? props.match.params.id : null,
      isLoading: isEditMode,
      isSubmitting: false,
      type: "opal",
      showModal: false,
      vehicleTypes: [],
      loadingVehicleTypes: false,

      // Form fields
      vehicle_number: '',
      vehicle_type_id: '',
      vehicle_model: '',
      capacity: '',
      mulkiya_expiry_date: '',
      ras_expiry_date: '',
      status: 'P',
      opal: true,

      // Driver fields
      driver_name: '',
      driver_phone: '',
      driver_license_number: '',
      driver_license_expiry_date: '',
      driver_date_of_birth: '',
      driver_opal_id: '',
      driver_ivms_url: '',
      driver_ivms_username: '',
      driver_ivms_password: '',
      driver_ddExpiryDate: '',

      // Documents (for new uploads)
      mulkiyaDocument: null,
      fitnessCertificate: null,
      ftwDocument: null,
      idCopy: null,

      // Existing documents arrays
      existingVehicleDocuments: [],
      existingDriverDocuments: [],

      errors: {},
      hideSidebar: false,

      // Modal states
      showConfirmModal: false,
      confirmModalConfig: {
        title: '',
        message: '',
        onConfirm: null,
        confirmText: '',
        cancelText: ''
      }
    };
  }

  componentDidMount() {
    const pathParts = window.location.pathname.split('/');
    const id = pathParts[pathParts.length - 2];
    console.log("ID from URL:", id);

    this.fetchVehicleType();

    if (id && id !== 'edit' && id !== 'vehicle-registration') {
      this.fetchVehicleDetails(id);
    } else {
      this.setState({ isLoading: false });
    }
  }

  fetchVehicleType = async () => {
    this.setState({ loadingVehicleTypes: true });
    try {
      const filters = {};
      const response = await getVehicleType(filters);

      if (response.success && response.data) {
        const vehicleTypes = response.data.map(vehicleType => ({
          id: vehicleType.id,
          value: vehicleType.id,
          label: vehicleType.name,
        }));

        this.setState({
          vehicleTypes,
          loadingVehicleTypes: false
        });
      } else {
        toast.error(response.message || 'Failed to fetch vehicle types');
        this.setState({ loadingVehicleTypes: false });
      }
    } catch (error) {
      console.error('Error fetching vehicle types:', error);
      toast.error('Error loading vehicle types');
      this.setState({ loadingVehicleTypes: false });
    }
  };

  fetchVehicleDetails = async (id) => {
    this.setState({ isLoading: true });
    try {
      const response = await getVehicleDetailsById(id);
      if (response.data) {
        const vehicle = response.data;
        console.log('Vehicle data:', vehicle);
        this.populateFormData(vehicle);
      } else {
        toast.error('Failed to fetch vehicle details');
        this.props.history.push('/vehicle-registration');
      }
    } catch (error) {
      console.error('Error fetching vehicle:', error);
      toast.error('Error loading vehicle details');
      this.props.history.push('/vehicle-registration');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  populateFormData = (vehicle) => {
    console.log('Populating form with vehicle:', vehicle);

    // Parse vehicle data
    const vehicleData = {
      vehicle_number: vehicle.vehicle_number || '',
      vehicle_type_id: vehicle.vehicle_type_id || '',
      vehicle_model: vehicle.vehicle_model || '',
      capacity: vehicle.capacity || '',
      mulkiya_expiry_date: vehicle.mulkiya_expiry_date?.split('T')[0] || '',
      status: vehicle.status || 'P',
      opal: vehicle.opal || false,
      type: vehicle.opal ? "opal" : "non-opal",
      ras_expiry_date: vehicle.ras_expiry_date?.split('T')[0] || '',
    };

    // Parse driver data if exists
    let driverData = {};
    if (vehicle.driver) {
      driverData = {
        driver_name: vehicle.driver.name || '',
        driver_phone: vehicle.driver.phone || '',
        driver_license_number: vehicle.driver.license_number || '',
        driver_license_expiry_date: vehicle.driver.license_expiry_date?.split('T')[0] || '',
        driver_date_of_birth: vehicle.driver.date_of_birth?.split('T')[0] || '',
        driver_opal_id: vehicle.driver.opal_id || '',
        driver_ivms_url: vehicle.driver.ivms_url || '',
        driver_ivms_username: vehicle.driver.ivms_username || '',
        driver_ivms_password: vehicle.driver.ivms_password || '',
        driver_ddExpiryDate: vehicle.driver.dd_certification_expiry?.split('T')[0] || '',
      };
    }

    // Parse existing documents
    const existingVehicleDocuments = vehicle.documents || [];
    const existingDriverDocuments = vehicle.driver?.documents || [];

    console.log('Existing vehicle docs:', existingVehicleDocuments);
    console.log('Existing driver docs:', existingDriverDocuments);

    this.setState({
      ...vehicleData,
      ...driverData,
      existingVehicleDocuments,
      existingDriverDocuments,
      isLoading: false
    });
  };

  handleInputChange = (field, value) => {
    this.setState({
      [field]: value,
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    });
  };

  handleVehicleTypeChange = (value) => {
    this.setState({
      type: value,
      opal: value === "opal",
      errors: {
        ...this.state.errors,
        ras_expiry_date: '',
        driver_ivms_url: '',
        driver_ivms_username: '',
        driver_ivms_password: '',
        driver_ddExpiryDate: '',
      }
    });
  };

  handleFileUpload = (field, event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 6 * 1024 * 1024) {
        this.setState({
          errors: {
            ...this.state.errors,
            [field]: 'File size should be less than 6MB'
          }
        });
        return;
      }

      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        this.setState({
          errors: {
            ...this.state.errors,
            [field]: 'Only PDF, JPG, PNG files are allowed'
          }
        });
        return;
      }

      this.setState({
        [field]: file,
        errors: {
          ...this.state.errors,
          [field]: ''
        }
      });
    }
  };

  validateForm = () => {
    const {
      vehicle_number,
      vehicle_type_id,
      vehicle_model,
      capacity,
      mulkiya_expiry_date,
      type,
      ras_expiry_date,
      driver_name,
      driver_phone,
      driver_license_number,
      driver_license_expiry_date,
      driver_ivms_url,
      driver_ivms_username,
      driver_ivms_password,
      driver_ddExpiryDate,
      mulkiyaDocument,
      fitnessCertificate,
      ftwDocument,
      idCopy,
      existingVehicleDocuments,
      existingDriverDocuments
    } = this.state;

    const errors = {};
    const today = new Date();

    // Vehicle validations
    if (!vehicle_number.trim()) {
      errors.vehicle_number = 'Vehicle number is required';
    }

    if (!vehicle_type_id) {
      errors.vehicle_type_id = 'Vehicle type is required';
    }

    if (!vehicle_model.trim()) {
      errors.vehicle_model = 'Model & Make is required';
    }

    if (!capacity.trim() || !/^\d+(\.\d+)?$/.test(capacity)) {
      errors.capacity = 'Enter a valid capacity in kg';
    }

    if (!mulkiya_expiry_date) {
      errors.mulkiya_expiry_date = 'Mulkiya expiry date is required';
    } else if (new Date(mulkiya_expiry_date) <= today) {
      errors.mulkiya_expiry_date = 'Mulkiya must not be expired';
    }

    // Check if mulkiya document exists (either existing or new)
    const hasMulkiyaDocument = existingVehicleDocuments.some(doc => doc.document_type === 'mulkiya') || mulkiyaDocument;
    if (!hasMulkiyaDocument && !this.state.isEditMode) {
      errors.mulkiyaDocument = 'Mulkiya document is required';
    }

    // Check if fitness certificate exists
    const hasFitnessCertificate = existingVehicleDocuments.some(doc => doc.document_type === 'insurance') || fitnessCertificate;
    if (!hasFitnessCertificate && !this.state.isEditMode) {
      errors.fitnessCertificate = 'Fitness certificate is required';
    }

    // OPAL specific validations
    if (type === "opal") {
      if (!ras_expiry_date) {
        errors.ras_expiry_date = 'RAS expiry date is required';
      } else if (new Date(ras_expiry_date) <= today) {
        errors.ras_expiry_date = 'RAS must not be expired';
      }
    }

    // Driver validations
    if (!driver_name.trim()) {
      errors.driver_name = 'Driver name is required';
    }

    if (!driver_phone.trim()) {
      errors.driver_phone = 'Contact number is required';
    }

    if (!driver_license_number.trim()) {
      errors.driver_license_number = 'License number is required';
    }

    if (!driver_license_expiry_date) {
      errors.driver_license_expiry_date = 'License expiry date is required';
    } else if (new Date(driver_license_expiry_date) <= today) {
      errors.driver_license_expiry_date = 'License must not be expired';
    }


    if (type === "opal") {
      if (!driver_ddExpiryDate) {
        errors.driver_ddExpiryDate = 'DD expiry date is required';
      } else if (new Date(driver_ddExpiryDate) <= today) {
        errors.driver_ddExpiryDate = 'DD must not be expired';
      }

      if (!driver_ivms_url.trim()) {
        errors.driver_ivms_url = 'IVMS URL is required';
      }

      if (!driver_ivms_username.trim()) {
        errors.driver_ivms_username = 'IVMS username is required';
      }

      if (!driver_ivms_password.trim()) {
        errors.driver_ivms_password = 'IVMS password is required';
      }
    }

    // Check if FTW document exists
    const hasFtwDocument = existingDriverDocuments.some(doc => doc.document_type === 'ftw') || ftwDocument;
    if (!hasFtwDocument && !this.state.isEditMode) {
      errors.ftwDocument = 'FTW document is required';
    }

    // Check if ID copy exists
    const hasIdCopy = existingDriverDocuments.some(doc => doc.document_type === 'id_copy') || idCopy;
    if (!hasIdCopy && !this.state.isEditMode) {
      errors.idCopy = 'ID copy is required';
    }

    return errors;
  };

  handleRemoveExistingDocument = (documentId, documentType) => {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: {
        title: 'Remove Document',
        message: 'Are you sure you want to remove this document? You will need to upload a new one.',
        onConfirm: () => {
          if (documentType === 'vehicle') {
            this.setState(prevState => ({
              existingVehicleDocuments: prevState.existingVehicleDocuments.filter(doc => doc.id !== documentId)
            }));
          } else {
            this.setState(prevState => ({
              existingDriverDocuments: prevState.existingDriverDocuments.filter(doc => doc.id !== documentId)
            }));
          }
          this.setState({ showConfirmModal: false });
        },
        confirmText: 'Remove',
        cancelText: 'Cancel'
      }
    });
  };

  handleSave = async () => {
    // Validate form
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });

      // Scroll to first error
      const firstErrorField = Object.keys(errors)[0];
      const element = document.querySelector(`[data-field="${firstErrorField}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }

      toast.error('Please fix the errors in the form before submitting.');
      return;
    }

    // Set submitting state
    this.setState({ isSubmitting: true });

    try {
      const formData = new FormData();
      const user = getLoggedUser();

      // Add vehicle data
      formData.append('vehicle_number', this.state.vehicle_number);
      formData.append('vehicle_type_id', this.state.vehicle_type_id);
      formData.append('vehicle_model', this.state.vehicle_model);
      formData.append('capacity', this.state.capacity);
      formData.append('mulkiya_expiry_date', this.state.mulkiya_expiry_date);
      formData.append('status', this.state.status);
      formData.append('opal', this.state.opal ? '1' : '0');

      // OPAL specific fields
      if (this.state.type === "opal") {
        formData.append('ras_expiry_date', this.state.ras_expiry_date);
      }

      // Add driver data
      const driverData = {
        name: this.state.driver_name,
        phone: this.state.driver_phone,
        license_number: this.state.driver_license_number,
        license_expiry_date: this.state.driver_license_expiry_date,
        date_of_birth: this.state.driver_date_of_birth,
        opal_id: this.state.driver_opal_id,
        status: this.state.status,
        opal: this.state.opal ? '1' : '0',
      };

      // OPAL driver fields
      if (this.state.type === "opal") {
        driverData.ivms_url = this.state.driver_ivms_url;
        driverData.ivms_username = this.state.driver_ivms_username;
        driverData.ivms_password = this.state.driver_ivms_password;
        driverData.dd_certificate = this.state.driver_ddExpiryDate;
        driverData.dd_certification_expiry = this.state.driver_ddExpiryDate;
      }

      formData.append('driver', JSON.stringify(driverData));

      // Add existing document IDs
      this.state.existingVehicleDocuments.forEach((doc, index) => {
        formData.append(`existing_vehicle_documents[${index}][id]`, doc.id);
        formData.append(`existing_vehicle_documents[${index}][document_type]`, doc.document_type);
      });

      this.state.existingDriverDocuments.forEach((doc, index) => {
        formData.append(`existing_driver_documents[${index}][id]`, doc.id);
        formData.append(`existing_driver_documents[${index}][document_type]`, doc.document_type);
      });

      // Add new vehicle documents
      if (this.state.mulkiyaDocument) {
        formData.append('documents[0][document_type]', 'mulkiya');
        formData.append('documents[0][file]', this.state.mulkiyaDocument);
      }

      if (this.state.fitnessCertificate) {
        formData.append('documents[1][document_type]', 'insurance');
        formData.append('documents[1][file]', this.state.fitnessCertificate);
      }

      // Add new driver documents
      if (this.state.ftwDocument) {
        formData.append('driver_documents[0][document_type]', 'ftw');
        formData.append('driver_documents[0][file]', this.state.ftwDocument);
      }

      if (this.state.idCopy) {
        formData.append('driver_documents[1][document_type]', 'id_copy');
        formData.append('driver_documents[1][file]', this.state.idCopy);
      }

      // Add company_id if user has it
      if (user && user.company_id) {
        formData.append('company_id', user.company_id);
      }

      // Debug log
      console.log('Sending FormData for update:');
      for (let pair of formData.entries()) {
        console.log(pair[0], ':', typeof pair[1] === 'object' ? pair[1].name || pair[1] : pair[1]);
      }

      // Make API call
      if (this.state.isEditMode) {
        const response = await updateVehicleDetailsRegistration(this.state.vehicleId, formData);

        if (response.success) {
          toast.success('Vehicle updated successfully!');
          this.props.history.push('/vehicles');
        } else {
          throw new Error(response.message || 'Failed to update vehicle');
        }
      } else {
        // For create mode, you would call a different API endpoint
        // const response = await createVehicleRegistration(formData);
        // Handle create response
        toast.success('Vehicle registered successfully!');
        this.props.history.push('/vehicles');
      }

    } catch (error) {
      console.error('Error saving vehicle:', error);
      toast.error(error.message || 'Failed to save vehicle. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleCancel = () => {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: {
        title: 'Cancel Changes',
        message: 'Are you sure you want to cancel? All unsaved changes will be lost.',
        onConfirm: () => {
          this.props.history.goBack();
          this.setState({ showConfirmModal: false });
        },
        confirmText: 'Yes, Cancel',
        cancelText: 'No, Continue'
      }
    });
  };

  resetForm = () => {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: {
        title: 'Reset Form',
        message: 'Are you sure you want to reset all form fields? This action cannot be undone.',
        onConfirm: () => {
          this.setState({
            vehicle_number: '',
            vehicle_type_id: '',
            vehicle_model: '',
            capacity: '',
            mulkiya_expiry_date: '',
            ras_expiry_date: '',
            type: "opal",
            opal: true,
            status: 'P',

            driver_name: '',
            driver_phone: '',
            driver_license_number: '',
            driver_license_expiry_date: '',
            driver_date_of_birth: '',
            driver_opal_id: '',
            driver_ivms_url: '',
            driver_ivms_username: '',
            driver_ivms_password: '',
            driver_ddExpiryDate: '',

            mulkiyaDocument: null,
            fitnessCertificate: null,
            ftwDocument: null,
            idCopy: null,

            existingVehicleDocuments: [],
            existingDriverDocuments: [],

            errors: {},
            showConfirmModal: false
          });
          toast.success('Form has been reset.');
        },
        confirmText: 'Reset',
        cancelText: 'Cancel'
      }
    });
  };

  handleDelete = async () => {
    this.setState({
      showConfirmModal: true,
      confirmModalConfig: {
        title: 'Delete Vehicle',
        message: 'Are you sure you want to delete this vehicle? This action cannot be undone.',
        onConfirm: async () => {
          try {
            // Call delete API
            // const response = await deleteVehicle(this.state.vehicleId);
            toast.success('Vehicle deleted successfully!');
            this.props.history.push('/vehicles');
          } catch (error) {
            console.error('Error deleting vehicle:', error);
            toast.error('Failed to delete vehicle. Please try again.');
          } finally {
            this.setState({ showConfirmModal: false });
          }
        },
        confirmText: 'Delete',
        cancelText: 'Cancel'
      }
    });
  };

  closeConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  render() {
    const {
      vehicle_number,
      vehicle_type_id,
      vehicle_model,
      capacity,
      type,
      mulkiya_expiry_date,
      ras_expiry_date,
      driver_name,
      driver_phone,
      driver_license_number,
      driver_license_expiry_date,
      driver_date_of_birth,
      driver_opal_id,
      driver_ivms_url,
      driver_ivms_username,
      driver_ivms_password,
      driver_ddExpiryDate,
      errors,
      isSubmitting,
      isLoading,
      vehicleTypes,
      loadingVehicleTypes,
      existingVehicleDocuments,
      existingDriverDocuments,
      showConfirmModal,
      confirmModalConfig
    } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("vehicle_registration")}
          subtitle="registration information and driver assignment"
        />
       <ConfirmModal
          show={showConfirmModal}
          onClose={this.closeConfirmModal}
          title={confirmModalConfig.title}
          message={confirmModalConfig.message}
          onConfirm={confirmModalConfig.onConfirm}
          confirmText={confirmModalConfig.confirmText}
          cancelText={confirmModalConfig.cancelText}
          loading={isSubmitting}
        />

        <section className="mt-5 site-visit-details-page">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div className={this.state.hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'}>
                <main className="main-content card">
                  <div className="page-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>

                    <div className="header-actions">
                      {this.state.isEditMode ? (
                        <>
                          <button
                            className="no-data-button me-2"
                            onClick={this.handleDelete}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {i18n.t('delete')}
                          </button>

                          <button
                            className="no-data-button me-2"
                            onClick={this.resetForm}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {i18n.t('reset_changes')}
                          </button>

                          <button
                            className="no-data-button me-2"
                            onClick={this.handleCancel}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {i18n.t('cancel')}
                          </button>

                          <button
                            className="btn-new"
                            onClick={this.handleSave}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {isSubmitting ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                {i18n.t('updating')}
                              </>
                            ) : (
                              i18n.t('update')
                            )}
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="button1 button1-secondary"
                            onClick={this.handleCancel}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {i18n.t('cancel')}
                          </button>

                          <button
                            className="button1 button1-primary"
                            onClick={this.handleSave}
                            disabled={isSubmitting}
                            type="button"
                          >
                            {isSubmitting ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                {i18n.t('submitting')}
                              </>
                            ) : (
                              i18n.t('submit')
                            )}
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="content">
                    {/* Vehicle Details Section */}
                    <section className="card-t1 vehicle-details">
                      <div className="form-grid">
                        <div className="form-group full-width">
                          <div className="section-header section-divider">
                            <div className="card-t1-header">
                              <Truck size={24} className="header-icon" />
                              <h2>{i18n.t('vehicle_details')}</h2>
                            </div>
                            <div style={{ display: "flex", gap: "5px" }}>
                              <button
                                type="button"
                                className={`button1 ${type === "opal" ? ' button1-primary' : ''}`}
                                onClick={() => this.handleVehicleTypeChange('opal')}
                                disabled={isSubmitting}
                              >
                                OPAL
                              </button>
                              <button
                                type="button"
                                className={`button1 ${type === "non-opal" ? 'button1-primary' : '' }`}
                                onClick={() => this.handleVehicleTypeChange('non-opal')}
                                disabled={isSubmitting}
                              >
                                NON OPAL
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Vehicle Number */}
                        <div className="form-group" data-field="vehicle_number">
                          <label>Vehicle Number *</label>
                          <input
                            type="text"
                            placeholder="e.g., MH12 AB 3456"
                            value={vehicle_number}
                            onChange={(e) => this.handleInputChange('vehicle_number', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.vehicle_number ? 'error' : ''}
                          />
                          {errors.vehicle_number && (
                            <span className="error-message">{errors.vehicle_number}</span>
                          )}
                        </div>

                        {/* Vehicle Type */}
                        <div className="form-group" data-field="vehicle_type_id">
                          <label>Vehicle Type *</label>
                          <select
                            value={vehicle_type_id}
                            onChange={(e) => this.handleInputChange('vehicle_type_id', e.target.value)}
                            disabled={loadingVehicleTypes || isSubmitting}
                            className={errors.vehicle_type_id ? 'error' : ''}
                          >
                            <option value="">Select Vehicle Type</option>
                            {loadingVehicleTypes ? (
                              <option value="" disabled>Loading Vehicle Types...</option>
                            ) : (
                              vehicleTypes.map(vehicleType => (
                                <option key={vehicleType.id} value={vehicleType.id}>
                                  {vehicleType.label}
                                </option>
                              ))
                            )}
                          </select>
                          {errors.vehicle_type_id && (
                            <span className="error-message">{errors.vehicle_type_id}</span>
                          )}
                          <button
                            type="button"
                            className="button1 button1-primary"
                            onClick={this.fetchVehicleType}
                            style={{ marginTop: '5px', fontSize: '12px', padding: '2px 8px' }}
                            disabled={loadingVehicleTypes || isSubmitting}
                          >
                            <RefreshCw size={12} /> Refresh List
                          </button>
                        </div>

                        {/* Model & Make */}
                        <div className="form-group" data-field="vehicle_model">
                          <label>Model & Make *</label>
                          <input
                            type="text"
                            placeholder="e.g., Tata Signa 4825.TK"
                            value={vehicle_model}
                            onChange={(e) => this.handleInputChange('vehicle_model', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.vehicle_model ? 'error' : ''}
                          />
                          {errors.vehicle_model && (
                            <span className="error-message">{errors.vehicle_model}</span>
                          )}
                        </div>

                        {/* Capacity */}
                        <div className="form-group" data-field="capacity">
                          <label>Capacity (KG) *</label>
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="Enter capacity in kg"
                            value={capacity}
                            onChange={(e) => this.handleInputChange('capacity', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.capacity ? 'error' : ''}
                          />
                          {errors.capacity && (
                            <span className="error-message">{errors.capacity}</span>
                          )}
                        </div>

                        {/* Mulkiya Expiry Date */}
                        <div className="form-group" data-field="mulkiya_expiry_date">
                          <label>Mulkiya Expiry Date *</label>
                          <input
                            type="date"
                            value={mulkiya_expiry_date}
                            onChange={(e) => this.handleInputChange('mulkiya_expiry_date', e.target.value)}
                            disabled={isSubmitting}
                            min={new Date().toISOString().split('T')[0]}
                            className={errors.mulkiya_expiry_date ? 'error' : ''}
                          />
                          {errors.mulkiya_expiry_date && (
                            <span className="error-message">{errors.mulkiya_expiry_date}</span>
                          )}
                        </div>

                        {/* OPAL Specific Fields */}
                        {type === "opal" && (
                          <>
                            {/* RAS Expiry Date */}
                            <div className="form-group" data-field="ras_expiry_date">
                              <label>RAS Expiry Date *</label>
                              <input
                                type="date"
                                value={ras_expiry_date}
                                onChange={(e) => this.handleInputChange('ras_expiry_date', e.target.value)}
                                disabled={isSubmitting}
                                min={new Date().toISOString().split('T')[0]}
                                className={errors.ras_expiry_date ? 'error' : ''}
                              />
                              {errors.ras_expiry_date && (
                                <span className="error-message">{errors.ras_expiry_date}</span>
                              )}
                            </div>
                          </>
                        )}
                      </div>

                      <div className="form-grid">
                        {/* Mulkiya Document */}
                        <div className="form-group" data-field="mulkiyaDocument">
                          <label>Mulkiya Document *</label>

                          {/* Show existing mulkiya document */}
                          {existingVehicleDocuments
                            .filter(doc => doc.document_type === 'mulkiya')
                            .map(doc => (
                              <div key={`existing-mulkiya-${doc.id}`} className="existing-document-preview">
                                <div className="document-preview">
                                  {doc.file_path && (
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                      alt="Mulkiya Document"
                                      style={{ maxWidth: '200px', maxHeight: '150px', cursor: 'pointer' }}
                                      onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`, '_blank')}
                                    />
                                  )}
                                </div>
                                <div className="document-actions mt-2">
                                  <a
                                    href={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#f0f9ff',
                                      color: '#0369a1',
                                      border: '1px solid #d1fae5',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <Eye size={14} /> View
                                  </a>
                                  <button
                                    type="button"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#fee2e2',
                                      color: '#dc2626',
                                      border: '1px solid #fef3c7',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => this.handleRemoveExistingDocument(doc.id, 'vehicle')}
                                    disabled={isSubmitting}
                                  >
                                    <Trash2 size={14} /> Remove
                                  </button>
                                </div>
                              </div>
                            ))
                          }

                          {/* Only show upload if no existing mulkiya document */}
                          {existingVehicleDocuments.filter(doc => doc.document_type === 'mulkiya').length === 0 && (
                            <div className="file-upload">
                              <Upload size={32} />
                              <p>
                                Drag & drop file or <span className="browse-link">browse</span>
                              </p>
                              <small>PDF, JPG, PNG Max 6MB</small>
                              <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.handleFileUpload('mulkiyaDocument', e)}
                                disabled={isSubmitting}
                                className={errors.mulkiyaDocument ? 'error-border' : ''}
                              />
                              {this.state.mulkiyaDocument && (
                                <div className="selected-file">
                                  Selected: {this.state.mulkiyaDocument.name}
                                </div>
                              )}
                            </div>
                          )}

                          {errors.mulkiyaDocument && (
                            <span className="error-message">{errors.mulkiyaDocument}</span>
                          )}
                        </div>

                        {/* Fitness Certificate */}
                        <div className="form-group" data-field="fitnessCertificate">
                          <label>Fitness Certificate *</label>

                          {/* Show existing fitness certificate */}
                          {existingVehicleDocuments
                            .filter(doc => doc.document_type === 'insurance')
                            .map(doc => (
                              <div key={`existing-fitness-${doc.id}`} className="existing-document-preview">
                                <div className="document-preview">
                                  {doc.file_path && (
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                      alt="Fitness Certificate"
                                      style={{ maxWidth: '200px', maxHeight: '150px', cursor: 'pointer' }}
                                      onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`, '_blank')}
                                    />
                                  )}
                                </div>
                                <div className="document-actions mt-2">
                                  <a
                                    href={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#f0f9ff',
                                      color: '#0369a1',
                                      border: '1px solid #d1fae5',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <Eye size={14} /> View
                                  </a>
                                  <button
                                    type="button"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#fee2e2',
                                      color: '#dc2626',
                                      border: '1px solid #fef3c7',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => this.handleRemoveExistingDocument(doc.id, 'vehicle')}
                                    disabled={isSubmitting}
                                  >
                                    <Trash2 size={14} /> Remove
                                  </button>
                                </div>
                              </div>
                            ))
                          }

                          {/* Only show upload if no existing fitness certificate */}
                          {existingVehicleDocuments.filter(doc => doc.document_type === 'insurance').length === 0 && (
                            <div className="file-upload">
                              <Upload size={32} />
                              <p>
                                Drag & drop file or <span className="browse-link">browse</span>
                              </p>
                              <small>PDF, JPG, PNG Max 6MB</small>
                              <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.handleFileUpload('fitnessCertificate', e)}
                                disabled={isSubmitting}
                                className={errors.fitnessCertificate ? 'error-border' : ''}
                              />
                              {this.state.fitnessCertificate && (
                                <div className="selected-file">
                                  Selected: {this.state.fitnessCertificate.name}
                                </div>
                              )}
                            </div>
                          )}

                          {errors.fitnessCertificate && (
                            <span className="error-message">{errors.fitnessCertificate}</span>
                          )}
                        </div>
                      </div>

                      {/* Driver Details Section */}
                      <div className="form-group full-width pt-3">
                        <div className="section-header section-divider">
                          <div className="card-t1-header">
                            <Truck size={24} className="header-icon" />
                            <h2>Driver Details</h2>
                          </div>
                        </div>
                      </div>

                      <div className="form-grid">
                        {/* Driver Name */}
                        <div className="form-group" data-field="driver_name">
                          <label>Full Name *</label>
                          <input
                            type="text"
                            placeholder="Enter Driver Name"
                            value={driver_name}
                            onChange={(e) => this.handleInputChange('driver_name', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.driver_name ? 'error' : ''}
                          />
                          {errors.driver_name && (
                            <span className="error-message">{errors.driver_name}</span>
                          )}
                        </div>

                        {/* Contact Number */}
                        <div className="form-group" data-field="driver_phone">
                          <label>Contact Number *</label>
                          <input
                            type="tel"
                            placeholder="e.g., +968 9123 4567"
                            value={driver_phone}
                            onChange={(e) => this.handleInputChange('driver_phone', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.driver_phone ? 'error' : ''}
                          />
                          {errors.driver_phone && (
                            <span className="error-message">{errors.driver_phone}</span>
                          )}
                        </div>


                        {/* License Number */}
                        <div className="form-group" data-field="driver_license_number">
                          <label>{i18n.t('license_number')} *</label>
                          <input
                            type="text"
                            placeholder="Enter License Number"
                            value={driver_license_number}
                            onChange={(e) => this.handleInputChange('driver_license_number', e.target.value)}
                            disabled={isSubmitting}
                            className={errors.driver_license_number ? 'error' : ''}
                          />
                          {errors.driver_license_number && (
                            <span className="error-message">{errors.driver_license_number}</span>
                          )}
                        </div>

                        {/* License Expiry Date */}
                        <div className="form-group" data-field="driver_license_expiry_date">
                          <label>{i18n.t('license_expiry_date')} *</label>
                          <input
                            type="date"
                            value={driver_license_expiry_date}
                            onChange={(e) => this.handleInputChange('driver_license_expiry_date', e.target.value)}
                            disabled={isSubmitting}
                            min={new Date().toISOString().split('T')[0]}
                            className={errors.driver_license_expiry_date ? 'error' : ''}
                          />
                          {errors.driver_license_expiry_date && (
                            <span className="error-message">{errors.driver_license_expiry_date}</span>
                          )}
                        </div>

                        {/* Date of Birth */}
                        <div className="form-group" data-field="driver_date_of_birth">
                          <label> {i18n.t('date_of_birth')}</label>
                          <input
                            type="date"
                            value={driver_date_of_birth}
                            onChange={(e) => this.handleInputChange('driver_date_of_birth', e.target.value)}
                            disabled={isSubmitting}
                            max={new Date().toISOString().split('T')[0]}
                          />
                        </div>

                        {/* OPAL Driver Fields */}
                        {type === "opal" && (
                          <>
                            {/* OPAL ID */}
                            <div className="form-group" data-field="driver_opal_id">
                              <label>OPAL ID</label>
                              <input
                                type="text"
                                placeholder="Enter OPAL ID"
                                value={driver_opal_id}
                                onChange={(e) => this.handleInputChange('driver_opal_id', e.target.value)}
                                disabled={isSubmitting}
                              />
                            </div>

                            {/* IVMS URL */}
                            <div className="form-group" data-field="driver_ivms_url">
                              <label>IVMS URL *</label>
                              <input
                                type="url"
                                placeholder="https://example.com"
                                value={driver_ivms_url}
                                onChange={(e) => this.handleInputChange('driver_ivms_url', e.target.value)}
                                disabled={isSubmitting}
                                className={errors.driver_ivms_url ? 'error' : ''}
                              />
                              {errors.driver_ivms_url && (
                                <span className="error-message">{errors.driver_ivms_url}</span>
                              )}
                            </div>

                            {/* IVMS Username */}
                            <div className="form-group" data-field="driver_ivms_username">
                              <label>IVMS Username *</label>
                              <input
                                type="text"
                                placeholder="Enter IVMS username"
                                value={driver_ivms_username}
                                onChange={(e) => this.handleInputChange('driver_ivms_username', e.target.value)}
                                disabled={isSubmitting}
                                className={errors.driver_ivms_username ? 'error' : ''}
                              />
                              {errors.driver_ivms_username && (
                                <span className="error-message">{errors.driver_ivms_username}</span>
                              )}
                            </div>

                            {/* IVMS Password */}
                            <div className="form-group" data-field="driver_ivms_password">
                              <label>IVMS Password *</label>
                              <input
                                type="text"
                                placeholder="Enter IVMS password"
                                value={driver_ivms_password}
                                onChange={(e) => this.handleInputChange('driver_ivms_password', e.target.value)}
                                disabled={isSubmitting}
                                className={errors.driver_ivms_password ? 'error' : ''}
                              />
                              {errors.driver_ivms_password && (
                                <span className="error-message">{errors.driver_ivms_password}</span>
                              )}
                            </div>

                            {/* DD Expiry Date */}
                            <div className="form-group" data-field="driver_ddExpiryDate">
                              <label>DD Expiry Date *</label>
                              <input
                                type="date"
                                value={driver_ddExpiryDate}
                                onChange={(e) => this.handleInputChange('driver_ddExpiryDate', e.target.value)}
                                disabled={isSubmitting}
                                min={new Date().toISOString().split('T')[0]}
                                className={errors.driver_ddExpiryDate ? 'error' : ''}
                              />
                              {errors.driver_ddExpiryDate && (
                                <span className="error-message">{errors.driver_ddExpiryDate}</span>
                              )}
                            </div>
                          </>
                        )}
                      </div>

                      <div className="form-grid">
                        {/* FTW Document */}
                        <div className="form-group" data-field="ftwDocument">
                          <label>FTW Document *</label>

                          {/* Show existing FTW document */}
                          {existingDriverDocuments
                            .filter(doc => doc.document_type === 'ftw')
                            .map(doc => (
                              <div key={`existing-ftw-${doc.id}`} className="existing-document-preview">
                                <div className="document-preview">
                                  {doc.file_path && (
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                      alt="FTW Document"
                                      style={{ maxWidth: '200px', maxHeight: '150px', cursor: 'pointer' }}
                                      onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`, '_blank')}
                                    />
                                  )}
                                </div>
                                <div className="document-actions mt-2">
                                  <a
                                    href={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#f0f9ff',
                                      color: '#0369a1',
                                      border: '1px solid #d1fae5',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}                                  >
                                    <Eye size={14} /> View
                                  </a>
                                  <button
                                    type="button"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#fee2e2',
                                      color: '#dc2626',
                                      border: '1px solid #fef3c7',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => this.handleRemoveExistingDocument(doc.id, 'driver')}
                                    disabled={isSubmitting}
                                  >
                                    <Trash2 size={14} /> Remove
                                  </button>
                                </div>
                              </div>
                            ))
                          }

                          {/* Only show upload if no existing FTW document */}
                          {existingDriverDocuments.filter(doc => doc.document_type === 'ftw').length === 0 && (
                            <div className="file-upload">
                              <Upload size={32} />
                              <p>
                                Drag & drop file or <span className="browse-link">browse</span>
                              </p>
                              <small>PDF, JPG, PNG Max 6MB</small>
                              <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.handleFileUpload('ftwDocument', e)}
                                disabled={isSubmitting}
                                className={errors.ftwDocument ? 'error-border' : ''}

                              />
                              {this.state.ftwDocument && (
                                <div className="selected-file">
                                  Selected: {this.state.ftwDocument.name}
                                </div>
                              )}
                            </div>
                          )}

                          {errors.ftwDocument && (
                            <span className="error-message">{errors.ftwDocument}</span>
                          )}
                        </div>

                        {/* ID Copy */}
                        <div className="form-group" data-field="idCopy">
                          <label>ID Copy *</label>

                          {/* Show existing ID copy */}
                          {existingDriverDocuments
                            .filter(doc => doc.document_type === 'id_copy')
                            .map(doc => (
                              <div key={`existing-id-copy-${doc.id}`} className="existing-document-preview">
                                <div className="document-preview">
                                  {doc.file_path && (
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                      alt="ID Copy"
                                      style={{ maxWidth: '200px', maxHeight: '150px', cursor: 'pointer' }}
                                      onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`, '_blank')}
                                    />
                                  )}
                                </div>
                                <div className="document-actions mt-2">
                                  <a
                                    href={`${process.env.REACT_APP_IMAGE_URL || ''}${doc.file_path}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#f0f9ff',
                                      color: '#0369a1',
                                      border: '1px solid #d1fae5',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <Eye size={14} /> View
                                  </a>
                                  <button
                                    type="button"
                                    className="btn-new btn-sm m-1"
                                    style={{
                                      backgroundColor: '#fee2e2',
                                      color: '#dc2626',
                                      border: '1px solid #fef3c7',
                                      opacity: 1,
                                      cursor: 'pointer'
                                    }}
                                    onClick={() => this.handleRemoveExistingDocument(doc.id, 'driver')}
                                    disabled={isSubmitting}
                                  >
                                    <Trash2 size={14} /> Remove
                                  </button>
                                </div>
                              </div>
                            ))
                          }

                          {/* Only show upload if no existing ID copy */}
                          {existingDriverDocuments.filter(doc => doc.document_type === 'id_copy').length === 0 && (
                            <div className="file-upload">
                              <Upload size={32} />
                              <p>
                                Drag & drop file or <span className="browse-link">browse</span>
                              </p>
                              <small>PDF, JPG, PNG Max 6MB</small>
                              <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => this.handleFileUpload('idCopy', e)}
                                disabled={isSubmitting}
                                className={errors.idCopy ? 'error-border' : ''}
                              />
                              {this.state.idCopy && (
                                <div className="selected-file">
                                  Selected: {this.state.idCopy.name}
                                </div>
                              )}
                            </div>
                          )}

                          {errors.idCopy && (
                            <span className="error-message">{errors.idCopy}</span>
                          )}
                        </div>
                      </div>
                    </section>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default VehicleRegistration;